<template>
  <div>
    <Button
      v-tooltip.bottom="iconOnly ? 'Redeem code' : undefined"
      v-bind="$attrs"
      :size="buttonSize === 'normal' ? undefined : buttonSize"
      outlined
      :label="iconOnly ? undefined : 'Redeem code'"
      :aria-label="iconOnly ? 'Redeem code' : undefined"
      icon="pi pi-ticket"
      @click="open = true"
    />
    <DialogsRedeemCode
      v-model="open"
      @redeemed="onRedeemed"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineOptions({ inheritAttrs: false })

withDefaults(defineProps<{
  buttonSize?: 'small' | 'normal' | 'large'
  // Just the ticket icon, for the phone top bar where the label doesn't fit
  iconOnly?: boolean
}>(), {
  buttonSize: 'normal',
  iconOnly: false,
})

const emit = defineEmits<{ (e: 'redeemed', v: { year: string, subkreweId: string }): void }>()

const open = ref(false)

function onRedeemed(info: { year: string, subkreweId: string }) {
  emit('redeemed', info)
  // Close the dialog after a successful redeem
  open.value = false
}
</script>
